import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild, HostListener, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import { InsightsService } from 'src/app/shared/insights/service/insights.service';
import { ExcelService } from 'src/app/shared/services/export-excel/export-excel.service';
import { HomeService } from 'src/app/shared/services/home.service';
import { SharedataService } from 'src/app/shared/share/service/sharedata.service';
import {ReportService} from '../service/report.service';
import { TrackerService } from '../service/tracker.service';
// import { ColDef, ColGroupDef, GridApi, NavigateToNextCellParams,CellPosition } from 'ag-grid-community';
import { MatSelect } from '@angular/material/select';
import { Subject } from 'rxjs';
import { DataValueType } from 'highcharts';
import { debounceTime } from 'rxjs/operators';
import { NotifierService } from 'angular-notifier';
import { SidePanelService } from 'src/app/shared/services/side-pannel/side-pannel.service';

@Component({
  selector: 'app-table-extraction',
  templateUrl: './table-extraction.component.html',
  styleUrls: ['./table-extraction.component.scss']
})
export class TableExtractionComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('tableParent', {static: false}) tableParent:ElementRef;
  @ViewChild('tablebody', {static: false}) tablebody:ElementRef
  @ViewChild('downloadSelect', {static: false}) DownloadFormat:MatSelect
  
  // private gridApi!: GridApi;
  // private gridColumnApi!: GridColumnApi;

  public headers:any = [];
  public uuid:string='';
  public downloadFormateSelected = 1;
  public sigdownloadFormateSelected = 1;
  public dataValueSelected = 1;
  public defaultColDef:any = {};
  public focusSubject = new Subject();
  public accessRoles:any;
  public currentTab:any = {};
  constructor(public reportService:ReportService, 
    public router:Router,
    private excelService: ExcelService,
    public homeService: HomeService,
    private activaterRoute:ActivatedRoute,
    public iService:InsightsService,
    public sService:SharedataService,
    private loginService: LoginService,
    private readonly renderer: Renderer2,
    public trackerService:TrackerService,
    public notifire:NotifierService,
    private sidePanelService:SidePanelService
    ) {

      this.reportService.emitSigResultClick.subscribe((result)=>{
        let buffer = 0;
        buffer = <number> result["overallLength"] + 2;
        let rIndex = result.rowIndex;
        if (result.count) {
          rIndex = rIndex + result.count
        }
        this.navigateToCellCoordinate({"c":result.colIndex + buffer,"r":rIndex, "cutName":result.cutName, "cutUUID":result.cutUUID,"parentPath":result.parentPath.replace(/[\])}.[{(]/g, '')})
      })
    this.reportService.isLoading = false;
    this.uuid = this.activaterRoute.snapshot.params['uuid'];
    if (!(this.reportService.studyId && this.reportService.studyId !="")) {
      this.reportService.getRepositoryDetailByFile(this.uuid)
    }
    // this.setupFile();
    // this.reportService.openExtrationFilter();
  
    
    // if(!this.reportService.detailsUUID || this.reportService.detailsUUID == ''){
    //   // this.router.navigate(['home/repository-report']);
    //   if (this.router.url.includes('qual')) {
    //     this.router.navigate(['home/qual/report/',this.uuid]);
    //   }else{
    //     this.router.navigate(['home/repository-report/details/',this.uuid]);
    //   }
      
    // }
   }

  ngOnInit() {
    this.accessRoles = JSON.parse(localStorage.getItem('access'))["access_rules"];
    this.focusSubject = new Subject<DataValueType>();
    this.focusSubject.pipe(debounceTime(200)).subscribe((value: DataValueType) => {
      this.locateCell(value);
  });
    this.iService.getInsightList({"uuid":this.uuid,"type":"file"});
    this.reportService.openExtrationFilter();
  }
  ngAfterViewInit(){
    this.startTimer();
  }

  // setupFile() {
  //   this.reportService.fileUUID = this.uuid;
  //   this.reportService.allfilesDetails();
  //   if (this.router.url.includes("table-extraction")) {
  //     this.reportService.sideTreeChangesDataTable();
  //   }
  //   if(this.router.url.includes('qual')) {
  //     this.reportService.isQual = true;
  //   } else {
  //     this.reportService.isQual = false;
  //   }
  //   this.reportService.getCutData(this.uuid);
  // }

  ngOnDestroy(){
    this.loginService.isSessionLoggedOut().subscribe((result) => {
      if(result['message'] == 'success') {
        this.submitTracker();
      }
    })
    // this.submitTracker();
    // this.gridApi = null;
    this.reportService.agGridData = [];
    this.reportService.selectedCuts = '';
    this.reportService.sigTestingOn = 'FullCrosstab';
    this.reportService.filter_name = '';
    this.reportService.formData = null;
    this.reportService.mainJsonData = [];
    this.reportService.treeItems = {};
    this.reportService.clubTreeItems = [];
    this.reportService.isData = false;
    this.reportService.clubbedOptions = {column:[],rows:{}};
    this.reportService.mainClubReq = {};
    this.reportService.otherChecks = {};
    this.reportService.sigbuttonLoader = false;
    this.homeService.openSidenav();
    this.reportService.close();
    this.iService.close();
    this.sService.close();
    this.reportService.onSignificanceReset();
    this.reportService.resetLastRequest();
    this.reportService.isSignificanceTest = false;
    this.reportService.sigResultTabOpen = false;
    this.reportService.SigResultClearOnngDestroy();
    this.reportService.hasSigTestAccess = false;
    this.reportService.hasBetaSigTestAccess = false;
    this.reportService.sigTestingtype = "";
    this.currentTab = {};

  }

  @HostListener('window:beforeunload',['$event'])
    unload(event)
    {
            event.preventDefault();
            event.returnValue = false;
            this.loginService.isSessionLoggedOut().subscribe((result) => {
              if(result['message'] == 'success') {
                this.submitTracker();
              }
            })
            // this.submitTracker();
    }

  // @HostListener('window:resize')
  //   onResize() {
  //     if (!this.gridApi) return;

  //     setTimeout(() => {
  //       this.gridApi.sizeColumnsToFit();
  //     });
  // }

  public interval: number = 0;
  public timer;
  startTimer(){
    this.stopTimer();
    this.timer = setInterval(() => {
      this.interval++;
      // console.log("focused in viewer ", this.interval)
    },1000);
  }
  stopTimer(){
    clearInterval(this.timer);
    // console.log("blure in viewer ", this.interval)
  }
  @HostListener('window:focus', ['$event'])
  onFocused(event) {
    this.startTimer();
  }
  @HostListener('window:blur', ['$event'])
  onBlur(event) {
    this.stopTimer();
  }

  // closeSidenav(){
  //   this.homeService.closeSidenav();
  // }

  breadcrumbClick(index){
    switch(index){
      case 1 : if(this.reportService.isQual){
        this.router.navigate(['qual/report/',this.reportService.studyId]);
        // this.router.navigate(['home/qual/report/',this.reportService.studyId]);
      }
      else{
        this.router.navigate(['repo/details/',this.reportService.studyId]);
        // this.router.navigate(['home/repository-report/details/',this.reportService.studyId]);
      }
      break;

      case 2 : if(this.reportService.isQual){
        this.router.navigate(['qual/interview/',this.reportService.studyId]);
        // this.router.navigate(['home/qual/interview/',this.reportService.studyId]);
      }
      else{
        this.router.navigate(['repo']);
        // this.router.navigate(['home/repository-report']);
      }
      break;
    }
  }

  getGridSize(length){
    const percent = (100/length).toFixed(1);
    return `repeat(`+length+`, minmax(60px, `+percent+`%))`;
  }

  downloadCrossTabData(type?:string){
    let lastRequest = JSON.parse(JSON.stringify(this.reportService.lastRequest));
    console.log("lastRequest",this.reportService.lastRequest)
    if(type && type != '' && (type === 'abs'|| type === 'pct' || type === 'both'))
      {
        lastRequest["getData"]['dataValue'] = type;
      }
    
    let body = {"file_uuid":this.reportService.fileUUID,"request":lastRequest}
    this.reportService.downloadCurrentCrosstab(body).subscribe(result =>{      
      if(result['status'] == 1){
        this.downloadFile(result['url']);
      }
      this.reportService.isLoading = false;
    }, error => {
      console.log('error : ', error);
      this.reportService.isLoading = false;
    });

// this code drow sheet to download from frontend
    // setTimeout(() => {
    //   this.excelService.exportMultiLevelJsonAsExcelFile(this.reportService.jsonData['sidecut'],"crosstab",this.reportService.abspct)  
    // }, 200);
  }

  downloadData(){
    if (this.downloadFormateSelected == 2) {
      let type = this.reportService.viewFormateSelected === 2 ? 'abs':this.reportService.viewFormateSelected === 3 ? 'pct': this.reportService.viewFormateSelected === 4 ?'both' : '';
      this.downloadCrossTabData(type);
    }else if (this.downloadFormateSelected == 3) {
      let type = this.reportService.viewFormateSelected === 2 ? 'abs':this.reportService.viewFormateSelected === 3 ? 'pct':'both';
      this.reportService.detailsUUID = this.reportService.fileUUID;
      this.reportService.downloadFile(type).subscribe(result =>{
        if(result['status'] == 1){
          this.downloadFile(result['url'][0]);
        }
        if(result['status'] == 4){
          this.notifire.notify('error',result['message']);
          this.sidePanelService.afterLoginNavigate();
        }
        this.reportService.isLoading = false;
      }, error => {
        console.log('error : ', error);
        this.reportService.isLoading = false;
      });
    }
    this.DownloadFormat.value = 1;
  }
  sigdownloadData(){
    if (this.sigdownloadFormateSelected == 2) {
      this.downloadCrossTabData();
    }else if (this.sigdownloadFormateSelected == 3) {
      this.reportService.detailsUUID = this.reportService.fileUUID;
      this.reportService.downloadFile().subscribe(result =>{
        if(result['status'] == 1){
          this.downloadFile(result['url'][0]);
          this.reportService.isLoading = false;
        }
        if(result['status'] == 4){
          this.notifire.notify('error',result['message']);
          this.sidePanelService.afterLoginNavigate();
        }
      }, error => {
        this.reportService.isLoading = false;
      });
    }
    this.DownloadFormat.value = 1;
  }

  downloadFile(url){
    let ahref:HTMLElement = document.getElementById('downloadFIleURL');
    const data = url;
    ahref.setAttribute('href', url);
    ahref.setAttribute('target', '_blank');
    ahref.setAttribute('download', this.reportService.fileName+'.'+this.reportService.fileType);
    ahref.click();
  }


  changeViewFormet(){
    if (this.reportService.viewFormateSelected == 2 && this.reportService.formData) {
      this.reportService.formData.patchValue({'dataValue':'absolute'});
      this.reportService.otherChecks['dataValue'] = 'absolute';
      this.reportService.lastRequest["getData"]["dataValue"] = 'absolute';
    }else if (this.reportService.viewFormateSelected == 3 && this.reportService.formData) {
      this.reportService.formData.patchValue({'dataValue':'percentage'});
      this.reportService.otherChecks['dataValue'] = 'percentage';
      this.reportService.lastRequest["getData"]["dataValue"] = 'percentage';
    }else if (this.reportService.viewFormateSelected == 4 && this.reportService.formData) {
      this.reportService.formData.patchValue({'dataValue':'both'});
      this.reportService.otherChecks['dataValue'] = 'both';
      this.reportService.lastRequest["getData"]["dataValue"] = 'both';
    }
    // this.reportService.assignLength()
    // this.reportService.refreshGridJson();

    // this.reportService.parseSidecutToGridJson(Object.keys(this.reportService.jsonDataForGrid['sidecut'])[0])
    // this.reportService.parseResultToGridJson()
    this.reportService.generateAgGridDataBlueprint()
    

    
  }

  tableThCounter(i:number){
    return new Array(i);
  }
  showCommentPanel(){
    this.iService.openInsight(this.reportService.fileUUID,'file',"this.requestService.requestDetails.title")
  }
  showSharePanel(){
    this.sService.openSharePanel(this.reportService.fileUUID,'file');
  }
  submitTracker(){
    this.stopTimer();
    let data = {}
    data['uuid'] = this.reportService.fileUUID;
    data['file_type'] = 'repo';
    data['viewtime'] = this.interval;
    data['session_id'] = this.reportService.trackerSessionId;
    data['action'] = 'exit';
    if (data['uuid'] && data['uuid'] != '') {
      this.trackerService.submitTracker(data);
    }
  }

  // onGridReady(params): void {
  //   if(!this.gridApi) {
  //       this.gridApi = params.api;
  //   }
  //   this.gridApi = params.api;

  //   // console.log("call grid api")
  //   // this.gridColumnApi = params.columnApi;
  // }

  // sizeToFit(): void {
  //   if (this.gridApi) {
  //   }
  //   this.gridApi.sizeColumnsToFit();
  // }

  // onModelUpdated(params): void {
  //     if(!this.gridApi) {
  //         this.gridApi = params.api;
  //     }
  //     this.sizeToFit();
  // }

  // onFirstDataRendered(): void {
  //   if (this.gridApi) {
  //   }
  //   this.gridApi.sizeColumnsToFit();
  // }
  showSignificanceTestingPanel(type:string)
  {
    this.reportService.sigTestingtype = type;
    this.reportService.isSignificanceTest = true;
    // if(this.reportService.isData)
    // {
    //   this.reportService.openExtrationClub(this.reportService.agGridData[0]['sideCut'],1);
    // }
  }
  SigExpandResult(tab){
    // this.reportService.sigResultExpand = !this.reportService.sigResultExpand;
    let sigResultExpand = tab.sigResultExpand
    this.reportService.agGridData.forEach(cut => {
      cut.sigResultExpand = false;
      if (cut.sideCut == tab.sideCut) {
        cut.sigResultExpand = !sigResultExpand;
      }
    });
  }

  expandGrid(tab, action?:boolean){
    this.currentTab = tab;
    if (!(tab.data && tab.data.length > 0)) {
      tab["gridExpandLoading"] = true;
      this.reportService.isLoading = true;
    }
    if (action) {
      // this.reportService.agGridData.find(grid =>{return grid.sideCutKey_UUID == tab.sideCutKey_UUID}).gridExpand = action;
      tab.gridExpand = action;
    }else{
      if(!tab.gridExpand)
      {
        tab['IterationSigHighResult'] = 0;
        this.reportService.sigHighlightsResultIterateIndex = 0;
      }
      // this.reportService.agGridData.find(grid =>{return grid.sideCutKey_UUID == tab.sideCutKey_UUID}).gridExpand = !tab.gridExpand;
      tab.gridExpand = !tab.gridExpand;
    }
  }
  showGrid(){
    this.currentTab["gridExpandLoading"] = false;
    this.reportService.isLoading = false;
  }

  checkTabHasSigResult(tab){
    let temp = this.reportService.sigResultArr.find(opt =>{ return opt['sidecut'] === tab.sideCut});
    return temp ? true : false;
  }
 
  navigateToCellCoordinate(coordinates){
    this.focusSubject.next(coordinates);
  }

  locateCell(coordinates){
    // let tab = this.reportService.agGridData.find(item =>{ return item.sideCut == coordinates.cutName})
    let tab = this.reportService.agGridData.find(item =>{ return item.sideCutKey_UUID == coordinates.cutUUID})
    if (!this.reportService.agGridData.find(grid =>{return grid.sideCutKey_UUID == tab.sideCutKey_UUID}).gridExpand) {
      // if (!this.reportService.agGridData.find(grid =>{return grid.sideCut == tab.sideCut}).gridExpand) {
      this.expandGrid(tab,true);
      setTimeout(() => {
        if (document.getElementsByClassName(this.reportService.slugGenerator(coordinates.cutName))[0]) {
          // if grid plotted before
          this.reportService.locateCell(coordinates);
        }else{
          setTimeout(() => {
            // if grid plotted first time
            this.reportService.locateCell(coordinates);
          }, 300);
        }
      }, 200);
    }else{
      this.reportService.locateCell(coordinates);
    }
    // console.log("coordinates ===> ",coordinates)
  }


}

  
